import { render, staticRenderFns } from "./Form_Check.vue?vue&type=template&id=19902970&scoped=true"
import script from "./Form_Check.vue?vue&type=script&lang=js"
export * from "./Form_Check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19902970",
  null
  
)

export default component.exports